import {
  isCreateUserAndStartConversationPayload,
  ValidMessagePayload,
  isValidMessagePayload
} from './types/MessageTypePayloads'
export enum MessageType {
  Auth = 'Auth',
  Buttons = 'Buttons',
  CreateUserAndStartConversation = 'CreateUserAndStartConversation',
  StartConversation = 'StartConversation',
  Text = 'Text',
  ActionTaken = 'ActionTaken',
  Typing = 'Typing',
  TakeoverEvent = 'TakeoverEvent',
  Carousel = 'Carousel',
  MultiSelect = 'MultiSelect',
  ProfileCollect = 'ProfileCollect',
  Media = 'Media',
  Command = 'Command',
  LocationPicker = 'LocationPicker',
  SpacePicker = 'Space Picker',
  Voice = 'Voice'
}
const invisibleMessageTypes: Array<MessageType> = [
  MessageType.Auth,
  MessageType.CreateUserAndStartConversation,
  MessageType.StartConversation,
  MessageType.ActionTaken,
  MessageType.Typing,
  MessageType.Command
]

export function isMessageInvisibile(message: MessageInterface): boolean {
  return invisibleMessageTypes.includes(message.type)
}

export function isMessageType(type: any): type is MessageType {
  return Object.values(MessageType).includes(type)
}

export enum SenderOrRecipientType {
  Bot = 'bot',
  BotUser = 'botUser',
  Agent = 'agent'
}
export function isSenderOrRecipientType(type: any): type is SenderOrRecipientType {
  return Object.values(SenderOrRecipientType).includes(type)
}
export interface SenderOrRecipient {
  id: string
  type: SenderOrRecipientType
  name?: string
  avatar?: string
  app?: string
}
export function isSenderOrRecipient(sOrR: any): sOrR is SenderOrRecipient {
  return (
    sOrR !== undefined &&
    (sOrR as SenderOrRecipient).id !== undefined &&
    (sOrR as SenderOrRecipient).type !== undefined &&
    isSenderOrRecipientType(sOrR.type)
  )
}

// We might want to subclass the message interface for all the different types of messages. That would let us
// have a constant type safe then we wouldn't have to create 500000 || statments and also maybe than I can just
// Have one simple interface and not even make it a class. Or do I want different classes? I'm not sure...

export enum ActionTakenType {
  Selected = 'selected',
  OptionsSelected = 'options_selected',
  URLSelected = 'url_selected',
  Other = 'other'
}

export function isActionTakenType(type: any): type is ActionTakenType {
  return Object.values(ActionTakenType).includes(type)
}

export interface ActionTaken {
  type: ActionTakenType
  target?: string
  data?: any
}

export function isActionTaken(actionTaken: any): actionTaken is ActionTaken {
  return (
    actionTaken !== undefined &&
    (actionTaken as ActionTaken).type !== undefined &&
    isActionTakenType(actionTaken.type)
  )
}
/**
 * @tsoaModel
 */
export interface MessageInterface {
  id: string
  to?: SenderOrRecipient // These Are Only Optional if  the Type is CreateUserAndStartConversation
  from?: SenderOrRecipient
  type: MessageType
  actionTaken?: ActionTaken
  created: number // This number is used in creation of the message
  received?: number // This is set by the receivedMessage method on the bot router;
  payload: ValidMessagePayload
}

// export function isValidPayload(message:any) {
//   let isValid
//   switch (message.type) {
//     case MessageType.ActionTaken: {
//       isValid = isActionTakenPayload(message.payload)
//       break
//     }
//     case MessageType.Auth: {
//       isValid = isAuthPayload(message.payload)
//       break
//     }
//     case MessageType.Buttons: {
//       isValid = isButtonsPayload(message.payload)
//       break
//     }
//     case MessageType.CreateUserAndStartConversation: {
//       isValid = isCreateUserAndStartConversationPayload(message.payload)
//       break
//     }
//     case MessageType.StartConversation: {
//       isValid = isStartConversationPayload(message.payload)
//       break
//     }
//     case MessageType.Text: {
//       isValid = isTextPayload(message.payload)
//       break
//     }
//     case MessageType.Typing: {
//       isValid = isTypingPayload(message.payload)
//       break
//     }
//     case MessageType.TakeoverEvent: {
//       isValid = isTakeoverEventPayload(message.payload)
//       break
//     }
//     case MessageType.Carousel: {
//       isValid = isCarouselPayload(message.payload)
//       break
//     }
//     case MessageType.Command: {
//       isValid = isCommandPayload(message.payload)
//       break
//     }
//     case MessageType.Media: {
//       isValid = isMediaPayload(message.payload)
//       break
//     }
//     case MessageType.MultiSelect: {
//       isValid = isMultiSelectPayload(message.payload)
//       break
//     }
//     case MessageType.LocationPicker: {
//       isValid = isLocationPickerPayload(message.payload)
//       break
//     }
//     case MessageType.SpacePicker: {
//       isValid = isSpacePickerPayload(message.payload)
//       break
//     }
//   }
//     return isValid;
// }

export function isMessage(message: any): message is MessageInterface {
  if (message == undefined) {
    return false
  }
  if (!message.type || !message.payload) {
    console.warn('No Validation For Message Payload', message)
    return false
  }

  if (message.type == MessageType.CreateUserAndStartConversation) {
    return (
      (message as MessageInterface).id !== undefined &&
      (message as MessageInterface).type !== undefined &&
      (message as MessageInterface).payload !== undefined &&
      isCreateUserAndStartConversationPayload(message.payload)
    )
  }
  let isValid = isValidMessagePayload(message.type, message.payload)

  // switch (message.type) {
  //   case MessageType.ActionTaken: {
  //     isValid = isActionTakenPayload(message.payload)
  //     break
  //   }
  //   case MessageType.Auth: {
  //     isValid = isAuthPayload(message.payload)
  //     break
  //   }
  //   case MessageType.Buttons: {
  //     isValid = isButtonsPayload(message.payload)
  //     break
  //   }
  //   case MessageType.CreateUserAndStartConversation: {
  //     isValid = isCreateUserAndStartConversationPayload(message.payload)
  //     break
  //   }
  //   case MessageType.StartConversation: {
  //     isValid = isStartConversationPayload(message.payload)
  //     break
  //   }
  //   case MessageType.Text: {
  //     isValid = isTextPayload(message.payload)
  //     break
  //   }
  //   case MessageType.Typing: {
  //     isValid = isTypingPayload(message.payload)
  //     break
  //   }
  //   case MessageType.TakeoverEvent: {
  //     isValid = isTakeoverEventPayload(message.payload)
  //     break
  //   }
  //   case MessageType.Carousel: {
  //     isValid = isCarouselPayload(message.payload)
  //     break
  //   }
  //   case MessageType.Command: {
  //     isValid = isCommandPayload(message.payload)
  //     break
  //   }
  //   case MessageType.Media: {
  //     isValid = isMediaPayload(message.payload)
  //     break
  //   }
  //   case MessageType.MultiSelect: {
  //     isValid = isMultiSelectPayload(message.payload)
  //     break
  //   }
  //   case MessageType.LocationPicker: {
  //     isValid = isLocationPickerPayload(message.payload)
  //     break
  //   }
  //   case MessageType.SpacePicker: {
  //     isValid = isSpacePickerPayload(message.payload)
  //     break
  //   }
  //   default: {
  //     console.warn('No Validation For Message Payload  Type', message.type)
  //     return false
  //     break
  //   }
  // }

  if (!isValid) {
    console.warn('Invalide message', message.type)
    return false
  }

  return (
    (message as MessageInterface).id !== undefined &&
    (message as MessageInterface).to !== undefined &&
    isSenderOrRecipient(message.to) &&
    (message as MessageInterface).from !== undefined &&
    isSenderOrRecipient(message.from) &&
    (message as MessageInterface).type !== undefined &&
    isMessageType(message.type)
  )
}
